import api from './api';
import type { Subscription } from '../types';

export const billingService = {
  getSubscription: async () => {
    const response = await api.get('/api/payment/subscription');
    return response.data.data.subscription as Subscription | null;
  },
};
